import type {CompRef} from '@wix/document-services-types'
import {set} from 'lodash'
import type {MeasurementsMap, MeasurementsMapAPI, RowsAndColumnsMap} from './types'

export const createMeasurementsMapAPI = (
    measurementsMap: MeasurementsMap,
    rowsAndColumnsMap: RowsAndColumnsMap
): MeasurementsMapAPI => {
    const setWidth = (compRef: CompRef, value: number) => {
        set(measurementsMap, [compRef.id, 'width'], value)
    }
    const setHeight = (compRef: CompRef, value: number) => {
        set(measurementsMap, [compRef.id, 'height'], value)
    }
    const setX = (compRef: CompRef, value: number) => {
        set(measurementsMap, [compRef.id, 'x'], value)
    }
    const setY = (compRef: CompRef, value: number) => {
        set(measurementsMap, [compRef.id, 'y'], value)
    }

    const getWidth = (compRef: CompRef) => {
        return measurementsMap[compRef.id]?.width
    }
    const getHeight = (compRef: CompRef) => {
        return measurementsMap[compRef.id]?.height
    }
    const getX = (compRef: CompRef) => {
        return measurementsMap[compRef.id]?.x
    }
    const getY = (compRef: CompRef) => {
        return measurementsMap[compRef.id]?.y
    }

    const setColumns = (compRef: CompRef, value: number[]) => {
        set(rowsAndColumnsMap, [compRef.id, 'columns'], value)
    }
    const setRows = (compRef: CompRef, value: number[]) => {
        set(rowsAndColumnsMap, [compRef.id, 'rows'], value)
    }

    const getColumns = (compRef: CompRef) => {
        return rowsAndColumnsMap[compRef.id]?.columns
    }
    const getRows = (compRef: CompRef) => {
        return rowsAndColumnsMap[compRef.id]?.rows
    }

    return {
        set: {
            width: setWidth,
            height: setHeight,
            x: setX,
            y: setY,
            columns: setColumns,
            rows: setRows
        },
        get: {
            width: getWidth,
            height: getHeight,
            x: getX,
            y: getY,
            columns: getColumns,
            rows: getRows
        }
    }
}
